<div mat-dialog-content class="aza-pa-dialog-content">
    <h3 class="aza-pa-primary-color">{{ data?.name }}</h3>
    <p class="aza-pa-flex-row">
        <mat-icon color="primary">date_range</mat-icon>
        <span>{{start}}</span>
    </p>
    <p class="aza-pa-flex-row">
        <mat-icon color="primary">date_range</mat-icon>
        <span>{{end}}</span>
    </p>
    <p class="aza-pa-flex-row">
        <mat-icon color="primary">language</mat-icon>
        <span>{{data?.timezone}}</span>
    </p>
</div>

<div mat-dialog-actions class="aza-pa-dialog-actions">
    <button action="close" mat-raised-button (click)="onClose()">
        {{ 'CLOSE' | translate }}
    </button>
    <button action="open_event" mat-raised-button color="primary" (click)="onOpenEvent()">
        {{ 'OPEN_EVENT' | translate }}
    </button>
</div>
